import { render, staticRenderFns } from "./RelatorioFaturamentoServicos.vue?vue&type=template&id=7dce9611"
import script from "./RelatorioFaturamentoServicos.vue?vue&type=script&lang=js"
export * from "./RelatorioFaturamentoServicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports